/*
 * NOTE: Do not edit this file.
 * It is replaced at build time to avoid exposing the package.json in production.
 */
import { version } from '../package.json'
import { dependencies } from '../package.json'

export const VERSION = version
export const VERSION_PLATFORM = dependencies['@ublique/platform']
export const VERSION_COMPONENTS = dependencies['@ublique/components']
